/**
 * dialogs.js — alert and confirm, as <dialog>s.
 *
 * A frame sandboxed without allow-modals makes the native ones do nothing, and
 * the editor runs in one whenever it is a sidepanel. One shows at a time; the
 * next waits for it.
 */

let last = Promise.resolve();

function show(text, buttons) {
  last = last.then(() => new Promise((resolve) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'notice';
    const body = document.createElement('p');
    body.textContent = text;
    // Not a method="dialog" form: a frame sandboxed without allow-forms blocks it.
    const form = document.createElement('form');
    for (const [label, value] of buttons) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.addEventListener('click', () => dialog.close(value));
      form.append(button);
    }
    dialog.append(body, form);
    // Escape closes without a button, which answers no.
    dialog.returnValue = '';
    dialog.addEventListener('close', () => { dialog.remove(); resolve(dialog.returnValue === 'yes'); });
    document.body.append(dialog);
    dialog.showModal();
  }));
  return last;
}

export const tell = (text) => show(text, [['OK', 'yes']]);

/** True for OK. */
export const ask = (text) => show(text, [['OK', 'yes'], ['Cancel', '']]);
